<template>
  <containElement>
  </containElement>
</template>

<script>
import containElement from '@/components/Container.vue'
import { getObjFromUrl, decodeAdvanced } from '@/utils'
import { getNameById } from '@/api/baseInfo'
import { getBrands } from '@/api/search'
export default {
  components: { containElement },
  /*computed: {
    searchParam() {
      return getObjFromUrl(window.location.href)
    },
  },*/
  methods: {
    //根据ID获取名称，适用于将地址直接输入到浏览器（尤其是未经过页面选择方式设置参数而是直接读取浏览器地址栏参数的跨域浏览器）中回车时，解决相关名称回显问题
    getDefaultNameData() {
      let brand_id = ''
      let param = { brand_id: brand_id, kol_id: this.$store.state.user.KolId }
      getNameById(param)
        .then((res) => {
          if (res.status == 'ok') {
            let data = res.result.data
            if (data.kol && data.kol.length > 0) {
              this.$store.dispatch('user/changeKolName', data.kol[0].kol_name)
              localStorage.setItem('kol_name', data.kol[0].kol_name)
            } else if (data.brand && data.brand.length > 0) {
              this.$store.dispatch('user/changeBrandName', data.brand)
              localStorage.setItem('brandName', JSON.stringify(data.brand))
            }
          }
        })
        .catch((e) => {})
    },
    //查询默认的十个品牌
    getDefaultBrandOptions() {
      let param = { brand_name: '' }
      getBrands(param).then((res) => {
        if (res.status == 'ok') {
          localStorage.setItem(
            'defaultBrandOption',
            JSON.stringify(res.result.data)
          )
        }
      })
    },
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        let param_val = getObjFromUrl(window.location.href)
        //console.log("kol", param_val.kol_id, param_val.kol_name);
        if (param_val.brand_id != undefined && param_val.brand_id != '') {
          this.$store.dispatch(
            'user/changeBrand_id',
            param_val.brand_id.split(',').map((item) => {
              return decodeURIComponent(item)
            })
          )
        }
        if (
          param_val.passActivedTab != undefined &&
          param_val.passActivedTab != ''
        ) {
          this.$store.dispatch(
            'user/changeActivedTab',
            decodeURIComponent(param_val.passActivedTab)
          )
        }
        if (param_val.cat_id != undefined && param_val.cat_id != '') {
          this.$store.dispatch(
            'user/changeCatId',
            decodeURIComponent(param_val.cat_id)
          )
        }
        if (param_val.cat_name != undefined && param_val.cat_name != '') {
          this.$store.dispatch(
            'user/changeCatName',
            decodeURIComponent(param_val.cat_name)
          )
        }
        if (param_val.rule_id != undefined) {
          this.$store.dispatch(
            'user/changeRuleId',
            decodeURIComponent(param_val.rule_id)
          )
        }
        if (param_val.analyse_typ != undefined) {
          this.$store.dispatch(
            'user/changeAnalyseTyp',
            decodeURIComponent(param_val.analyse_typ)
          )
        }
        if (param_val.r_rule_id != undefined) {
          this.$store.dispatch(
            'user/changeRouterRuleId',
            decodeURIComponent(param_val.r_rule_id)
          )
        }
        if (param_val.wx_uid != undefined) {
          this.$store.dispatch(
            'user/changeRouterWxuid',
            decodeURIComponent(param_val.wx_uid)
          )
        }
        if (param_val.r_analyse_typ != undefined) {
          this.$store.dispatch(
            'user/changeRouterAnalyseTyp',
            decodeURIComponent(param_val.r_analyse_typ)
          )
        }
        if (param_val.words != undefined) {
          this.$store.dispatch(
            'user/changeWords',
            decodeURIComponent(param_val.words)
          )
        }
        if (param_val.issue_id != undefined) {
          this.$store.dispatch(
            'user/changeIssueId',
            decodeURIComponent(param_val.issue_id)
          )
        }
        if (param_val.label_level != undefined) {
          this.$store.dispatch(
            'user/changeLabelLevel',
            decodeURIComponent(param_val.label_level)
          )
        }
        if (param_val.aspect_type != undefined) {
          this.$store.dispatch(
            'user/changeAspectType',
            decodeURIComponent(param_val.aspect_type)
          )
        }
        if (param_val.selected_type != undefined) {
          this.$store.dispatch(
            'user/changeSelectedType',
            decodeURIComponent(param_val.selected_type)
          )
        }
        if (param_val.word != undefined) {
          this.$store.dispatch(
            'user/changeselectedKeyWords',
            decodeURIComponent(param_val.word)
          )
        }
        if (param_val.plat != undefined && param_val.plat != '') {
          this.$store.dispatch(
            'user/changeplants',
            param_val.plat.split(',').map((item) => {
              return decodeURIComponent(item)
            })
          )
        }
        if (param_val.kol_id != undefined) {
          this.$store.dispatch(
            'user/changeKolId',
            decodeURIComponent(param_val.kol_id)
          )
        }
        if (param_val.kol_name != undefined) {
          this.$store.dispatch(
            'user/changeKolName',
            decodeURIComponent(param_val.kol_name)
          )
        }
        if (param_val.start != undefined) {
          this.$store.dispatch(
            'user/changeStartMonth',
            decodeURIComponent(param_val.start)
          )
        }
        if (param_val.end != undefined) {
          this.$store.dispatch(
            'user/changeEndMonth',
            decodeURIComponent(param_val.end)
          )
        }
        if (param_val.CloudWord != undefined) {
          this.$store.dispatch(
            'user/changeCloudWord',
            decodeURIComponent(param_val.CloudWord)
          )
        }
        if (param_val.postBrandId != undefined) {
          this.$store.dispatch(
            'user/changeBrandId2',
            decodeURIComponent(param_val.postBrandId)
          )
        }
        if (param_val.postBrandName != undefined) {
          this.$store.dispatch(
            'user/changePostBrandName',
            decodeURIComponent(param_val.postBrandName)
          )
        }
        if (param_val.client_id != undefined) {
          this.$store.dispatch(
            'user/changeClientId',
            decodeURIComponent(param_val.client_id)
          )
        }
        if (param_val.sign != undefined) {
          this.$store.dispatch(
            'user/changeSign',
            decodeURIComponent(param_val.sign)
          )
        }
        if (param_val.user_id != undefined) {
          this.$store.dispatch(
            'user/changeUserId',
            decodeURIComponent(param_val.user_id)
          )
        }
        if (param_val.pm_id != undefined) {
          this.$store.dispatch(
            'user/changePmId',
            decodeURIComponent(param_val.pm_id)
          )
        }
        if (param_val.cf_selected_type != undefined) {
          this.$store.dispatch(
            'user/changeCfSelectedType',
            decodeAdvanced(param_val.cf_selected_type)
          )
        }
        if (param_val.cf_word != undefined) {
          this.$store.dispatch(
            'user/changeCfWord',
            decodeAdvanced(param_val.cf_word)
          )
        }
        if (
          param_val.cf_selected_type == undefined &&
          param_val.cf_word == undefined
        ) {
          const { word, selected_type, pm_id } = param_val
          if (word && selected_type) {
            // word 和 selected_type 都存在的情况
            const isIssueWithPmId = pm_id && selected_type !== 'issue'

            this.$store.dispatch(
              'user/changeCfSelectedType',
              isIssueWithPmId ? ['issue', selected_type] : [selected_type]
            )

            this.$store.dispatch(
              'user/changeCfWord',
              isIssueWithPmId
                ? [pm_id, decodeURIComponent(word)]
                : pm_id
                ? [pm_id]
                : [decodeURIComponent(word)]
            )
          } else if (pm_id) {
            // 只有 pm_id 的情况
            this.$store.dispatch('user/changeCfSelectedType', ['issue'])
            this.$store.dispatch('user/changeCfWord', [pm_id])
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    // window.addEventListener('beforeunload', (e) => {
    //   debugger
    // })
    this.getDefaultNameData()
    //this.getDefaultBrandOptions()
  },
}
</script>

<style>
</style>